const { addFamilyToWebProject, addFamilyToWebProjectWithAuthentication } = require('../../util/add_to_web_project_util.js');
/**
 * A service used to manage the "add fonts to web project" modal workflow.
 * @ngInject
 * @deprecated use the util functions instead
 */
function AddFontsToWebProjectService() {
  return {
    addFamilyToWebProject: addFamilyToWebProject,
    addFamilyToWebProjectWithAuthentication: addFamilyToWebProjectWithAuthentication
  };
}

module.exports = AddFontsToWebProjectService;
